import { Serializers } from "@megaron/serializers";

export const productCodeStatuses = ["blank", "active", "redeemed", "destroyed", "expired"] as const;
export type ProductCodeStatus = typeof productCodeStatuses[number];

export const productCodeStatusSerializer = Serializers.stringOneOf(...productCodeStatuses);
